import React from 'react';
import './App.css';

class Wrapper extends React.Component{
  constructor(){
    super();
    this.state = {showModal: false, items:false};
    this.items = false;
    this.initItems();
    this.showModal = this.showModal.bind(this);
    this.hideModal = this.hideModal.bind(this);
  }

  showModal = () => {
    window.$('html, body').addClass('is-reveal-open');
    this.setState({ showModal: true });
  };

  hideModal = () => {
    window.$('html, body').removeClass('is-reveal-open');
    this.setState({ showModal: false });
  };

  initItems = () => {
    const url = 'https://www.ohlinsusa.com/motorcycle-springs/compare';
 //   const url = 'http://ohlins.test/motorcycle-springs/compare';
    const info = document.getElementById('harley-compare-wrapper');
    const make = info.dataset.make;
    const model = info.dataset.model;
    const year = info.dataset.year;
    this.bike = info.dataset.bike;
    let endp = url + '?make=' + make +'&model=' + model + '&year=' + year;
    window.fetch(endp)
    .then((response) => response.json())
    .then((data) => {
      if(data.length === 0){
        data = false;
      }
      this.items = data;
      this.setState({items:this.items});
    })
  }

  componentDidMount(){
    this.setState({items:this.items});
  }

  render = () => {
    if(this.state.items !== false){
      if(this.state.showModal){
        return (
          <div className='modal'>
            <ComparisonGrid items={this.state.items} close={this.hideModal} bike={this.bike} />
          </div>
          );
      } else {
        return (
          <div className='modal-open'>
            <ComparisonButton open={this.showModal} />
          </div>
          );

      }
    }

  }

}

function App() {
  return (
    <div className="comparison-grid">
      <Wrapper/>
    </div>
  );
}

class ComparisonSummary extends React.Component{
  render(){
    if (typeof this.props.icon !== 'undefined') {
      return (
        <div className = 'comparison-attr columns'>
          <img src={'/assets/images/' + this.props.icon} alt={this.props.name} />
          <p>{this.props.value}</p>
        </div>
        );
      }
    else{
      return (
        <div className='comparison-attr columns'>
          <h3>{this.props.value}</h3>
          <p>{this.props.name}</p>
          </div>
        );
    }
  }
}

class ComparisonAdjustment extends React.Component{
  render(){
    if(this.props.value !== 'No'){

    return (
      <div className = 'comparison-attr columns'>
        {typeof this.props.icon !== 'undefined' &&
          <img src={'/assets/images/' + this.props.icon} alt={this.props.name} />
        }
        <p>{this.props.name}</p>
      </div>
      );
    }
    else{
      return (
        <div className='comparison-attr columns'>
          <p className='attr-no'><i className="fa fa-minus"></i>
</p>
        </div>
        );
    }
  }
}

class ComparisonPreference extends React.Component{
  render(){

    return (
      <div className = 'comparison-attr columns'>
        <h3>{this.props.value}</h3>
        <p>{this.props.name}</p>
        {typeof this.props.notes !== 'undefined' &&
         <p className='small'>{this.props.notes}</p>
        }
      </div>
      );
  }
}

class ComparisonSelect extends React.Component{
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    const val = JSON.parse(e.target.value);
    this.props.onChange(val.key,val.value);
  }

  render(){
    const items = this.props.items.map((item) =>
              <option value={JSON.stringify({value:item.title,key:this.props.columnIndex})} key={item.title}>{item.title}</option>
    );      
    return (
      <div className = 'comparison-select columns'>
         <select value={JSON.stringify({value:this.props.value,key:this.props.columnIndex})} onChange={this.handleChange}>
          {items}
          </select>
      </div>
      );
  }
}

class ComparisonGrid extends React.Component{
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    const columns = props.items.slice(0,3);
    this.state = {columns:columns};
    this.timer = null;
    this.items = props.items;
  }

  componentDidMount() {
    this.handleResize();
    window.addEventListener('resize', () => this.handleResize())
    const titles = Array.from(document.getElementsByClassName('harley-compare-item'),el => el.dataset.item);
    const that = this;
    titles.forEach( (t,i) => that.handleChange(i,t));
    //console.log(titles);
    //const titles = selected.map( el => el.dataset.item);
  }

  handleResize(){
    let containerWidth = window.innerWidth;
    let count = Math.max(Math.min(Math.floor(containerWidth / 300),3),2);
    window.clearTimeout(this.timer);
    let that = this;
    this.timer = window.setTimeout( function() {
      that.setState(
        function(state){
          let columns = state.columns;
          if(columns.length < count){
            columns.push(that.items[0]);
          }else{
            columns = columns.slice(0,count);
          }
          return {columns:columns};
        }
      );
    }, 500);
  }


  handleChange(index, value) {
    const item = this.items.filter((i) => i.title === value);
    this.setState((state) => {
      let cols = state.columns;
      cols[index] = item[0];
      return {columns:cols};
    });
  }
  render(){
      const summary = this.items[0].summary.map((x,i) =>
          <div className = 'row'>
            {this.state.columns.map( function(c, ii){
              let attr = c.summary[i];
              return <ComparisonSummary value = {attr.value} name={attr.name} key={attr.name+ii} icon = {attr.icon}/>;
              }
             )}
          </div>
      );
      const adjustments = this.items[0].adjustments.map((x,i) =>
          <div className = 'row'>
            {this.state.columns.map( function(c, ii){
              let attr = c.adjustments[i];
              return <ComparisonAdjustment value = {attr.value} name={attr.name} key={attr.name+ii} icon = {attr.icon}/>;
             })}
          </div>
      );
      const preferences = this.items[0].preferences.map((x,i) =>
          <div className = 'row'>
            {this.state.columns.map( function(c, ii){
              let attr = c.preferences[i];
              return <ComparisonPreference value = {attr.value} name={attr.name} key={attr.name+ii} icon = {attr.icon} notes={attr.notes}/>;
              }
             )}
          </div>
      );
    return (
      <div className='container'>
        <button className="close-button" aria-label="Close modal" type="button" onClick={this.props.close}>
          <span aria-hidden="true">&times;</span>
        </button>
            <h2 className='text-center'>Compare {this.props.bike} Shocks</h2>
          <p className='text-center'>
            <a className='underline' href='/suspension-products/motorcycle/harleydavidson'>Shop All Harley Products</a>
            &nbsp;
            &nbsp;
            &nbsp;
            <a className='underline' href='/dealers&type=moto'>Find a Dealer</a>
          </p>
        <div className = 'row select'>
        {this.state.columns.map((c,i) => <ComparisonSelect value={c.title} items={this.items} onChange={this.handleChange} key={i} columnIndex={i}/>)}
        </div>
      <div className = 'row'>
        {this.state.columns.map((c) =>
          <div className = 'comparison-image columns'>
            <img src={c.image.src + '?w=400'} alt={c.image.alt}/>
          </div>
         )}
      </div>
      <div className = 'row title'>
      {this.state.columns.map((c,i) => 
        <div className = 'comparison-title columns' key={i}>
          <h3>{c.title}</h3>
          <p className='small'>fits years {c.years}</p>
          <h3>${c.price}</h3>
          <p>
          <a href={c.link} className='underline'>BUY</a>
          </p>
        </div>
        )}
      </div>
      <div className='row'>
        <div className='small-24 columns'>
          <h3 className='left'>Summary</h3>
          <hr/>
        </div>
      </div>
        {summary}
      <div className='row'>
        <div className='small-24 columns'>
          <h3 className='left'>Adjustments</h3>
          <hr/>
        </div>
      </div>
        {adjustments}
      <div className='row'>
        <div className='small-24 columns'>
          <h3 className='left'>Rider Preferences</h3>
          <hr/>
        </div>
      </div>
        {preferences}
        <div className = 'row'>
        {this.state.columns.map((c,i) => 
          <div className = 'comparison-title columns' key={i}>
            <p>
            <a href={c.link} className='button blue'>Buy Now</a>
            </p>
          </div>
          )}
        </div>
      </div>
      );
  }
}


class ComparisonButton extends React.Component{
  render(){
    return (
      <button className='button blue' id='compare-modal-open' onClick={this.props.open}>Compare</button>
      );
  }
}

export default App;
